import type { User } from '../../stores/useAuth';

const PULSE_INTERNAL_CUSTOMER_ID =
  process.env.REACT_APP_PULSE_INTERNAL_CUSTOMER_ID || 'eliza';

export function canAccessPulseAdmin(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.is_superuser || user.permissions.includes('platform:admin')) return true;
  return Boolean(
    user.customer_id === PULSE_INTERNAL_CUSTOMER_ID
      && user.permissions.includes('pulse:access'),
  );
}
